import React, { useEffect, useState } from "react";
import DashboardLeftMenu from "../DashboardLeftMenu";
import DashboardHeader from "../../Header/DashboardHeader";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { VerificationDetail } from "../api/Api";
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Verificationreport = () => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;

  // URL params: filter_type, startdate, enddate
  const { filter_type, startdate, enddate } = useParams();

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    dataList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter_type]);

  const dataList = async () => {
    setLoading(true);
    setError("");

    const payload = {
      user_id: userId,
      token: userToken,
      method: "VerificationDetail",
      fromdate: startdate,
      todate: enddate,
      filter_type: filter_type, // "approve", "reject", or "all"
    };

    try {
      const { data } = await VerificationDetail(payload);

      if (data.success) {
        let records = Array.isArray(data.data) ? data.data : [data.data];

        // ✅ Filter logic added here
        if (filter_type === "approve") {
          records = records.filter(
            (x) => parseInt(x.approve_clickcount || 0) > 0
          );
        } else if (filter_type === "reject") {
          records = records.filter(
            (x) => parseInt(x.reject_clickcount || 0) > 0
          );
        }

        setData(records);
      } else {
        setData([]);
        setError(data.message || "No data found.");
      }
    } catch (err) {
      setError("Something went wrong while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = data.filter((x) => {
    if (search.trim() === "") return true;
    const s = search.toLowerCase();
    return (
      x.main_url?.toLowerCase().includes(s) ||
      x.ip?.toLowerCase().includes(s) ||
      x.from_email?.toLowerCase().includes(s) ||
      x.to_email?.toLowerCase().includes(s)
    );
  });

  return (
    <div className="wrapper">
      <DashboardLeftMenu />
      <div className="main">
        <DashboardHeader />
        <main className="content">
          <div className="card">
            <div className="card-body">
              <div className="container-fluid p-0">
                <div className="p-2">
                  <div className="row">
                    <div className="col-6">
                      <h5 className="card-title text-capitalize">
                        Email Verification –{" "}
                        {filter_type === "approve"
                          ? "Approved"
                          : filter_type === "reject"
                          ? "Rejected"
                          : "All"}{" "}
                        Records
                      </h5>
                    </div>
                    <div className="col-6">
                      <div className="input-group mb-3">
                        <div className="input-group-prepend float-right">
                          <span className="input-group-text">
                            <FontAwesomeIcon icon={faSearch} />
                          </span>
                        </div>
                        <input
                          type="text"
                          id="searchInput"
                          name="searchdata"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          className="form-control float-right"
                          placeholder="Search by email, IP, or URL"
                        />
                      </div>
                    </div>
                  </div>

                  {loading ? (
                    <div className="text-center my-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : error ? (
                    <div className="alert alert-danger text-center">{error}</div>
                  ) : filteredData.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-striped table-sm">
                        <thead>
                          <tr>
                            <th>From Email</th>
                            <th>To Email</th>
                            <th>IP</th>
                            {filter_type === "all" && <th>Status</th>}
                            <th>Device</th>
                            <th>Visit Time</th>
                            <th>Created</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData.map((item, i) => (
                            <tr key={i}>
                              <td>{item?.from_email || "N/A"}</td>
                              <td>{item?.to_email || "N/A"}</td>
                              <td>{item?.ip || "N/A"}</td>
                              {filter_type === "all" && (
                                <td>
                                  <span
                                    className={`badge ${
                                      item?.approve_clickcount === "1"
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {item?.approve_clickcount === "1"
                                      ? "Approved"
                                      : "Rejected"}
                                  </span>
                                </td>
                              )}
                              <td>{item?.url_device || "N/A"}</td>
                              <td>{item?.url_visit_time || "N/A"}</td>
                              <td>{item?.created || "N/A"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center">
                      <div className="card-body">
                        <img
                          alt="Empty Data"
                          className="project-empty-img"
                          src={EmptyImg}
                        />
                        <p>No Records Found</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Verificationreport;
